import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import auth from '../../services/auth'; // Assuming auth.check() is an async function

// Asynchronous function to check authentication
const checkAuthenticated = async () =>
    auth.check().catch((error) => {
        console.error('Authentication check failed:', error);
        return false; // Default to not authenticated on error
    });

// ProtectedRoute component
export default function ProtectedRoute({ children }) {
    const [isAuthenticated, setIsAuth] = useState(null); // `null` to indicate loading state
    const hasCheckedAuth = useRef(false); // Prevent double calls
    const location = useLocation(); // Get the current location

    useEffect(() => {
        if (hasCheckedAuth.current) return; // Skip if already checked

        hasCheckedAuth.current = true; // Mark as checked

        const checkAuth = async () => {
            const result = await checkAuthenticated();
            setIsAuth(result);
        };

        checkAuth();
    }, []);

    // Render loading state while waiting for authentication check
    if (isAuthenticated === null) {
        return (
            <Box display='flex' justifyContent='center' alignItems='center' height='100vh'>
                <CircularProgress />
            </Box>
        );
    }

    // Navigate to login if not authenticated, passing the current location as state
    if (!isAuthenticated) {
        return <Navigate to='/login' state={{ from: location }} />;
    }

    // Render children if authenticated
    return children;
}
